/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {useRef, useEffect} from 'react'
import { connect } from 'react-redux'
import { string, func, shape } from 'prop-types'
import Icon from 'common/components/icon'
import {AsdaCustomLink} from "../asda-custom-link";
import {getModifiedStringForNav} from "../../services/utility/cms";
import { getCurrentViewPort } from '../../services/utility'

export const SubMenuHamBurger = ({ linkName, dispatch, ui, onMenuClick, SubNav, isOpen }) => {

  const wrapperRef = useRef(null);
  const isOpenRef= useRef(isOpen)

  useEffect(()=> {isOpenRef.current = isOpen},[isOpen])

  useEffect(() => {
    function handleClickOutside(event) {
      if (isOpenRef.current && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onMenuClick(isOpenRef)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {

    const currentViewPort = getCurrentViewPort()
    const mobileDevicesPorts = ['small', 'large', 'medium']

    if(isOpen && mobileDevicesPorts.includes(currentViewPort)){

      const lastItem = SubNav[SubNav.length-1]
      const lastItemTitle = getModifiedStringForNav(lastItem.link.title, 30)

      let firstEl = document.querySelector(".submenu-button")
      let lastEl = document.getElementById(lastItemTitle)

      firstEl.focus()

      const keydownHandlerLast = (e) => {
        var evt = e || window.event
        var keyCode = evt.which || evt.keyCode
        if(keyCode === 9) { 
          if(evt.preventDefault) evt.preventDefault()
          else evt.returnValue = false
          firstEl.focus()
        }
      }
    
      const keydownHandlerFirst = (e) => {
        var evt = e || window.event
        var keyCode = evt.which || evt.keyCode
        if(keyCode === 9 && evt.shiftKey) { 
          if(evt.preventDefault) evt.preventDefault()
          else evt.returnValue = false
          lastEl.focus()
        }
      }

      if(lastEl.addEventListener) lastEl.addEventListener('keydown', keydownHandlerLast, false)
      if(firstEl.addEventListener) firstEl.addEventListener('keydown', keydownHandlerFirst, false)

    }
  },[isOpen, window.innerWidth])

  return (
    <li className={`sub-menu-container ${isOpen ? 'active' : ''}`} ref={wrapperRef}>
      <div className={`sub-menu custom-link ${ui.subMenuOpen ? 'active' : ''}`} tabIndex = {window.innerWidth > 960 ? "-1" : "0"} >
        <a
          className="sub-nav"
          id="nav-toggle"
          onClick={() => {
            onMenuClick(isOpen)
            dispatch({ type: 'TOGGLE_SUBMENU' })
          }}
          aria-label= {window.innerWidth > 960 ? "" : `${linkName}, list ${SubNav.length} items`}
        >
          <span className="submenu-hamburger-label">{linkName || 'Menu'}</span>
          <Icon name={`${isOpen ? 'upArrow' : 'downArrow'}`} size="medium" id="icon" label={`${linkName}, list ${SubNav.length} items`}/>
        </a>
      </div>
      {
        isOpen &&
        <button onClick={onMenuClick} className="submenu-button">
          <Icon name="back" size="medium" />
          Back
        </button>
      }
      <ul className={`submenu-nav ${isOpen ? "open" : ""}`}>
        {
          SubNav.map(({
                        link: {
                          clickThrough: {
                            value,
                          },
                          title,
                        },
                      }, index) => {
            const linkObj = { path: value }
            return <AsdaCustomLink
              link={linkObj}
              linkName={getModifiedStringForNav(title, 30)}
              key={`AsdaCustomLink-${index}`}
            />
          })
        }
      </ul>
    </li>

  )
}

SubMenuHamBurger.propTypes = {
  linkName: string.isRequired,
  dispatch: func.isRequired,
  ui: shape({}).isRequired,
}

export default connect()(SubMenuHamBurger)



// WEBPACK FOOTER //
// ./components/secondary-nav/SubMenuHamBurger.js